const splitGeoJSON = require('./lib/cut').default;

module.exports = splitGeoJSON;
